import React from 'react';
import {
  Box,
  Grid,
  Typography,
  Divider,
  Chip
} from '@mui/material';

const DetallePedidoExpandido = ({ pedido }) => {
  
  const formatFechaCompleta = (fechaString) => {
    if (!fechaString) return 'N/A';
    const date = new Date(fechaString);
    return date.toLocaleDateString('es-AR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  return (
    <Box sx={{ p: 1.5, backgroundColor: '#f8f9fa', borderTop: '1px solid #e0e0e0' }}>
      <Typography variant="subtitle2" fontWeight="bold" color="primary" gutterBottom>
        Pedido #{pedido.id}
      </Typography>
      
      <Grid container spacing={1.5}>
        {/* Columna izquierda */}
        <Grid item xs={12} md={6}>
          <Box sx={{ mb: 1.5 }}>
            <Typography variant="caption" color="textSecondary" display="block">
              Cliente
            </Typography>
            <Typography variant="body2">
              {pedido.cliente} - {pedido.sucursal_cliente}
            </Typography>
          </Box>
          
          <Box sx={{ mb: 1.5 }}>
            <Typography variant="caption" color="textSecondary" display="block">
              Dirección
            </Typography>
            <Typography variant="body2" sx={{ fontSize: '0.8rem' }}>
              {pedido.direccion_entrega}
            </Typography>
          </Box>
          
          <Grid container spacing={1}>
            
            <Grid item xs={6}>
              <Typography variant="caption" color="textSecondary" display="block">
                Cambio
              </Typography>
              <Typography variant="body2">
                {pedido.cambio}
              </Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography variant="caption" color="textSecondary" display="block">
                Chofer
              </Typography>
              <Typography variant="body2">
                {pedido.nombre_apellido || 'No asignado'}
              </Typography>
            </Grid>
            
          </Grid>
        </Grid>
        
        {/* Columna derecha */}
        <Grid item xs={12} md={6}>
          <Box sx={{ mb: 1.5 }}>
            <Typography variant="caption" color="textSecondary" display="block">
              Observaciones
            </Typography>
            <Typography variant="body2" sx={{ 
            //   p: 0.5,
              backgroundColor: pedido.observaciones ? '#e8f5e8' : '#f5f5f5',
              borderRadius: 0.5,
            //   minHeight: 40,
              fontSize: '0.8rem'
            }}>
              {pedido.observaciones || 'Sin observaciones'}
            </Typography>
          </Box>
          
          {pedido.obs_reclamo && (
            <Box sx={{ mb: 1 }}>
              <Typography variant="caption" color="error" display="block">
                Reclamo
              </Typography>
              <Typography variant="body2" color="error" sx={{ fontSize: '0.8rem' }}>
                {pedido.obs_reclamo}
              </Typography>
            </Box>
          )}
          
          <Grid item xs={6}>
              <Typography variant="caption" color="textSecondary" display="block">
                Fecha
              </Typography>
              <Typography variant="body2">
                {formatFechaCompleta(pedido.fecha_orden)}
              </Typography>
            </Grid>
          <Box sx={{ mt: 1 }}>
            <Typography variant="caption" color="textSecondary" display="block">
              Productos
            </Typography>
            <Typography variant="body2">
              {pedido.producto}
            </Typography>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default DetallePedidoExpandido;